import {
    FETCH_UPDATING_MERCHANT_REQUEST,
    FETCH_UPDATING_MERCHANT_SUCCESS,
    FETCH_UPDATING_MERCHANT_ERROR,
    SHOW_SETTLEMENT_LOADER,
    HIDE_SETTLEMENT_LOADER,
} from './MerchantOnboardStatus.constants';
import MerchantOnBoardStatusList from './models/MerchantOnboardStatusModel';

const initialState = {
    tableData: [],
    pagination: {},
    error: {},
    isLoading: false,
};

export const merchantOnboardStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_UPDATING_MERCHANT_REQUEST: {
            return {
                ...state,
                ...action.payload,
                error: {},
            };
        }
        case FETCH_UPDATING_MERCHANT_SUCCESS:
            const merchantOnboardStatusData = new MerchantOnBoardStatusList(
                action.payload
            );
            return {
                ...state,
                ...merchantOnboardStatusData,
            };
        case FETCH_UPDATING_MERCHANT_ERROR: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case SHOW_SETTLEMENT_LOADER:
            return { ...state, isLoading: true };
        case HIDE_SETTLEMENT_LOADER:
            return { ...state, isLoading: false };
        default:
            return state;
    }
};
